import { NonIdealState } from "@blueprintjs/core";
import React, { ErrorInfo, ReactNode } from "react";

export interface ErrorBoundaryProps {
    children: ReactNode;
}

export interface ErrorBoundaryState {
    hasError: boolean;
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    public state: ErrorBoundaryState = { hasError: false };

    public static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    public componentDidCatch(error: Error, info: ErrorInfo) {
        console.error(error, info);
    }

    public render() {
        if (this.state.hasError) {
            return (
                <NonIdealState
                    title="Something went wrong"
                    description="Whoops, we ran into a problem. Try refreshing the page?"
                />
            );
        }

        return this.props.children;
    }
}
